import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { bool, func } from "prop-types";
import React from "react";
import { connect } from "react-redux";
import { MEMBER_BEING_LOADED, MEMBER_UPDATED } from '../store/actions';
import { getRequest } from './api-client';
var loadedMember = false;

var WithMemberBase = /*#__PURE__*/function (_React$Component) {
  _inherits(WithMemberBase, _React$Component);

  var _super = /*#__PURE__*/_createSuper(WithMemberBase);

  function WithMemberBase(props) {
    var _this;

    _classCallCheck(this, WithMemberBase);

    _this = _super.call(this, props);
    _this.checkForMemberUpdated = _this.checkForMemberUpdated.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(WithMemberBase, [{
    key: "checkForMemberUpdated",
    value: function checkForMemberUpdated() {
      var _this2 = this;

      this.props.memberBeingLoaded();
      var requestUrl = this.props.isBridgekeeperEnabled ? "/api/auth/v1/users/me" : "/api/v1/members/me";
      return getRequest(requestUrl).forbidden(function () {
        return _this2.props.memberUpdated(null);
      }).unauthorized(function () {
        return _this2.props.memberUpdated(null);
      }).json(function (_ref) {
        var member = _ref.member,
            user = _ref.user;
        var memberObj = _this2.props.isBridgekeeperEnabled ? user : member;

        _this2.props.memberUpdated(memberObj);
      });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!loadedMember) {
        loadedMember = true;
        this.checkForMemberUpdated();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          member = _this$props.member,
          logout = _this$props.logout,
          children = _this$props.children,
          isLoading = _this$props.isLoading;
      return children({
        member: member,
        logout: logout,
        isLoading: isLoading,
        checkForMemberUpdated: this.checkForMemberUpdated
      });
    }
  }]);

  return WithMemberBase;
}(React.Component);

WithMemberBase.defaultProps = {
  isBridgekeeperEnabled: false
};

function mapStateToProps(_ref2) {
  var member = _ref2.member,
      memberLoading = _ref2.memberLoading;
  return {
    member: member || null,
    // undefined on server side
    isLoading: memberLoading === true || memberLoading === undefined
  };
}

function mapDispatchToProps(dispatch, ownProps) {
  var logoutRequestUrl = ownProps.isBridgekeeperEnabled ? "/api/auth/v1/logout" : "/api/logout";
  return {
    memberBeingLoaded: function memberBeingLoaded() {
      return dispatch({
        type: MEMBER_BEING_LOADED
      });
    },
    memberUpdated: function memberUpdated(member) {
      return dispatch({
        type: MEMBER_UPDATED,
        member: member
      });
    },
    logout: function logout() {
      return getRequest(logoutRequestUrl).res(function () {
        return dispatch({
          type: MEMBER_UPDATED,
          member: null
        });
      });
    }
  };
}
/**
 * This is a render props component which will call your callback with the current logged in member. It will automatically call `/api/v1/members/me` to figure out if you are logged in, and replace the contents in the store and callback. In future, this may use LocalStorage to cache the member for some time.
 *
 * The render will also be passed a function to call for logging out, and another to force the library to check if the member is now logged in.
 *
 * On initial load, the `isLoading` prop will be set, which will become false when the user is loaded. Use this field to avoid showing a Login Button while fetch is happening.
 *
 * In order to update the current member, call `checkForMemberUpdated`.
 *
 * In order to make bridgekeeper api calls for the current member and logout, `isBridgekeeperEnabled` prop needs to set to true. The default value is `false`.
 *
 * Example
 * ```javascript
 * import { WithMember } from '@quintype/components';
 *
 * function MyView({ member, logout, checkForMemberUpdated }) {
 *   return member ? <div>{member.name} <a onClick={logout}>Logout</a></div> : <div>Please Login!</div>;
 * }
 *
 * <WithMember>
 *   {({ member, logout, isLoading }) => (
 *     <MyView member={member} logout={logout} isLoading={isLoading} />
 *   )}
 * </WithMember>
 * ```
 * @component
 * @category Login
 */


export var WithMember = /*#__PURE__*/connect(mapStateToProps, mapDispatchToProps)(WithMemberBase);